<script setup lang="ts">
import * as Sentry from '@sentry/nuxt';

const error = useError();
console.log('error', error);

if (error.value) {
    Sentry.captureException(error.value);
}

const isServerError = computed(() => {
    const code = error.value?.statusCode || 500;
    return code >= 500 && code < 600;
});

function reloadPage() {
    window.location.reload();
}
</script>

<template>
    <NuxtLayout name="default">
        <div class="py-16">
            <div class="mt-20 text-gray-500 max-w-xl mx-auto text-5xl text-center">
                {{ error?.statusMessage || 'Unexpected error' }}
            </div>
            <div class="mt-20 px-4 text-center">
                <button v-if="isServerError" class="text-lg px-4 text-blue-600 hover:text-blue-700" @click="reloadPage">
                    Reload
                </button>
                <NuxtLink v-else class="text-lg px-4 text-blue-600 hover:text-blue-700" to="/"> Home </NuxtLink>
            </div>
        </div>
    </NuxtLayout>
</template>
